<template>
  <el-dialog :title="$t('borrowManage.delete.title')" :visible.sync="visible" width="30%" @close="handleClose">
    <div style="text-align:center;padding:20px 0;">
      <i class="el-icon-warning" style="color:#E6A23C;font-size:40px;"></i>
      <p style="margin-top:10px;">{{ $t('borrowManage.delete.confirmText') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleConfirm">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { deleteBorrow } from '@/api/oa/borrowManageApi'

export default {
  name: 'DeleteBorrow',
  data() {
    return {
      visible: false,
      deleteData: {
        borrowId: '',
        communityId: ''
      }
    }
  },
  methods: {
    open(row) {
      this.visible = true
      this.deleteData = {
        borrowId: row.borrowId,
        communityId: getCommunityId()
      }
    },
    handleClose() {
      this.deleteData = {
        borrowId: '',
        communityId: ''
      }
    },
    async handleConfirm() {
      try {
        await deleteBorrow(this.deleteData)
        this.$message.success(this.$t('common.operationSuccess'))
        this.visible = false
        this.$emit('success')
      } catch (error) {
        this.$message.error(error.message || this.$t('common.operationFailed'))
      }
    }
  }
}
</script>